import { IAPIRoutes } from "../../../../config";

export type IUserRepository = ReturnType<typeof UserRepositoryFactory>;

export const UserRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getUserBetaFeatures: IGetUserBetaFeaturesAPI = async () =>
    GET(
      APIRoutes.apiUserBetaFeature,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const updateUserInfo: IUpdateUserInfoAPI = async (payload) =>
    PUT(APIRoutes.apiUpdateUserInfo, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const signupUser: ISignupUserAPI = async (payload) =>
    POST(APIRoutes.apiSignup, payload);

  return {
    getUserBetaFeatures,
    updateUserInfo,
    signupUser,
  };
};
